import { render, staticRenderFns } from "./sliderValidate.vue?vue&type=template&id=c3a06ac6&scoped=true"
import script from "./sliderValidate.vue?vue&type=script&lang=js"
export * from "./sliderValidate.vue?vue&type=script&lang=js"
import style0 from "./sliderValidate.vue?vue&type=style&index=0&id=c3a06ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a06ac6",
  null
  
)

export default component.exports